import { render, staticRenderFns } from "./Dense.vue?vue&type=template&id=7a112900&"
import script from "./Dense.vue?vue&type=script&lang=js&"
export * from "./Dense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports